<template>
  <div>
    <div class="text-center text-3xl font-bold">
      {{ title }}
    </div>
    <div class="w-full my-2">
      <v-text-field
        v-model="otp"
        outlined
        :label="caption"
        clearable
      ></v-text-field>
    </div>
    <div class="border-b-2 border-gray-500 pb-6">
      <v-btn color="primary" class="w-full" @click="submit">Submit</v-btn>
    </div>
    <div class="my-6 border rounded p-4 border-gray-400">
      <div class="text-center">
        {{ note }}
      </div>
      <div class="text-center my-2">
        <v-btn color="success">Update contact information</v-btn>
      </div>
      <div>
        Is your registered email inactive? Update your information here.
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "@/EventBus";

export default {
  data() {
    return {
      otp: "",
      title: "ONE-TIME-PIN (OTP)",
      caption:
        "Enter your OTP sent to your mobile number registered with Moldex.",
      note: "Did you change your mobile number? Submit your new registered contact information here.",
    };
  },
  methods: {
    submit() {
      if (!this.otp) {
        var msg = "Please enter the OTP";
        EventBus.$emit("snackbarMyAccount", msg);
      } else {
        EventBus.$emit("otpDialog_close");
      }
    },
  },
};
</script>
